module.exports = __webpack_public_path__ + "static/media/wheel.0329bc5f.svg";